const Loader = ({ 
  size = 'medium', 
  color = 'primary', 
  text = 'Cargando...',
  fullScreen = false,
  className = ''
}) => {
  const sizes = {
    small: 'h-6 w-6',
    medium: 'h-12 w-12',
    large: 'h-16 w-16'
  }
    
  const colors = {
    primary: 'text-primary-text',
    gray: 'text-primary-gray',
    white: 'text-white'
  }
    
  const textSizes = {
    small: 'text-sm',
    medium: 'text-base',
    large: 'text-lg'
  }
    
  const spinnerClasses = `animate-spin ${sizes[size]} ${colors[color]}`
  const textClasses = `mt-4 ${textSizes[size]} ${colors[color]} font-medium`
    
  const content = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <svg 
        className={spinnerClasses}
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        />
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && <p className={textClasses}>{text}</p>}
    </div>
  )
    
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 z-50 flex items-center justify-center">
        {content}
      </div>
    )
  }
    
  return content
}

export default Loader